// Tech systems used across the app. Keep in sync with backend `TECH_SYSTEMS`.
export const TECH_SYSTEMS = [
  'traction', 'suction', 'sweeping', 'brush_arms', 'suction_mouth',
  'high_pressure', 'water_dust_control', 'battery', 'charging',
  'electronics', 'hydraulics',
];

export const SYSTEM_LABELS = {
  traction:           { it: 'trazione',           es: 'tracción',           en: 'traction' },
  suction:            { it: 'aspirazione',        es: 'aspiración',         en: 'suction' },
  sweeping:           { it: 'spazzamento',        es: 'barrido',            en: 'sweeping' },
  brush_arms:         { it: 'bracci spazzole',    es: 'brazos cepillo',     en: 'brush arms' },
  suction_mouth:      { it: 'bocca aspirante',    es: 'boca aspirante',     en: 'suction mouth' },
  high_pressure:      { it: 'alta pressione',     es: 'alta presión',       en: 'high pressure' },
  water_dust_control: { it: 'acqua / polveri',    es: 'agua / polvo',       en: 'water / dust control' },
  battery:            { it: 'batteria',           es: 'batería',            en: 'battery' },
  charging:           { it: 'ricarica',           es: 'carga',              en: 'charging' },
  electronics:        { it: 'elettronica',        es: 'electrónica',        en: 'electronics' },
  hydraulics:         { it: 'idraulica',          es: 'hidráulica',         en: 'hydraulics' },
};

export function systemLabel(system, lang = 'it') {
  if (!system) return '';
  const l = SYSTEM_LABELS[system];
  if (!l) return system;
  return l[lang] || l.it || system;
}
